import { render } from "./ExpertStatisticsDIDReport.vue?vue&type=template&id=50423992"
import script from "./ExpertStatisticsDIDReport.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsDIDReport.vue?vue&type=script&lang=js"

import "./ExpertStatisticsDIDReport.vue?vue&type=style&index=0&id=50423992&lang=css"
script.render = render

export default script